import generateMetaTitle from './generateMetaTitle'
import generateMetaDescription from './generateMetaDescription'
import generateMetaImage from './generateMetaImage'

export default function generateMetaInfo (defaultMeta, post, options) {
  const opts = {
    lang: post.polylang.current.lang,
    locale: post.polylang.current.locale,
    ...options
  }
  // console.log('post', post)
  const title = generateMetaTitle(defaultMeta, post)
  const description = generateMetaDescription(defaultMeta, post)
  const image = generateMetaImage(defaultMeta, post)
  const metaInfo = {
    title: title.pageTitle,
    htmlAttrs: {
      lang: opts.lang
    },
    meta: [
      { name: 'description', content: description.metaDescription },
      // { name: 'keywords', content: post.keywords },
      // { name: 'author', content: post.author },
      // { property: 'og:locale', content: opts.locale },
      { property: 'og:site_name', content: defaultMeta.og_site_name },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: title.ogTitle },
      { property: 'og:description', content: description.ogDescription },
      { name: 'twitter:title', content: title.ogTitle },
      { name: 'twitter:description', content: description.ogDescription },
      { name: 'twitter:card', content: 'summary_large_image' }
      // { name: 'twitter:site', content: '@publisher_handle' },
      // { name: 'twitter:creator', content: '@designathon15' },
    ],
    link: []
  }

  if (opts.isHome) {
    if (post.link.endsWith('home/')) {
      post.link = post.link.replace('home/', '')
    }
    if (post.polylang.translations.en && post.polylang.translations.en.permalink.endsWith('home/')) {
      post.polylang.translations.en.permalink = post.polylang.translations.en.permalink.replace('home/', '')
    }
    if (post.polylang.translations.de && post.polylang.translations.de.permalink.endsWith('home/')) {
      post.polylang.translations.de.permalink = post.polylang.translations.de.permalink.replace('home/', '')
    }
  }

  if (!opts.error) {
    if (post.link) {
      metaInfo.link.push(
        { rel: 'canonical', href: post.link }
      )
    }
  }

  if (!opts.error) {
    if (post.link) {
      metaInfo.meta.push(
        { property: 'og:url', content: post.link }
      )
    }

    if (post.polylang && post.polylang.translations.en) {
      metaInfo.link.push(
        { rel: 'alternate', href: post.link, hreflang: 'de' },
        { rel: 'alternate', href: post.polylang.translations.en.permalink, hreflang: 'en' }
      )
    } else if (post.polylang && post.polylang.translations.de) {
      metaInfo.link.push(
        { rel: 'alternate', href: post.link, hreflang: 'en' },
        { rel: 'alternate', href: post.polylang.translations.de.permalink, hreflang: 'de' }
      )
    }
  }

  if (image) {
    metaInfo.meta.push(
      { property: 'og:image', content: image },
      { name: 'twitter:image', content: image }
    )
  }

  if (opts.error) {
    metaInfo.meta.push(
      { name: 'prerender-status-code', content: opts.error }
    )
  }

  return metaInfo
}



// WEBPACK FOOTER //
// ./client/common/generateMetaInfo.js